import * as React from 'react';
import { cn } from '@restworld/utils-common';
const dropdownOptionsStyle =
  'absolute mt-2 max-h-[304px] w-full overflow-auto rounded-lg z-50 bg-neutral-10 scrollbar-none p-2 text-base border border-neutral-90 shadow-[0px 4px 16px 0px rgba(0, 0, 26, 0.25)]';
const dropdownOptionStyle =
  'relative cursor-pointer select-none py-0 px-5 flex items-center text-base text-neutral-700 font-medium hover:bg-neutral-30 hover:rounded-lg';

export const DropdownWrapper = ({ dropdownSubWrapperStyle, className, ...props }: any) => (
  <ul
    className={cn(
      'flex flex-col gap-3 p-4 min-h-[14rem] max-h-[18rem] overflow-y-auto',
      dropdownSubWrapperStyle,
      className
    )}
    {...props}
  />
);
export const GoogleAutoCompleteAddressItemStyled = ({
  dropdownItemStyle,
  isActive,
  activeItemStyle,
  className,
  ...props
}: any) => (
  <li
    className={cn(
      'w-full flex items-center justify-between cursor-pointer',
      'py-2.5',
      dropdownItemStyle,
      isActive ? activeItemStyle : '',
      [dropdownOptionStyle, 'py-3 min-h-fit my-3 px-0 lg:px-2 lg:my-1 lg:py-2'],
      className
    )}
    {...props}
  />
);
export const DropdownElementWrapper = ({ dropdownMainWrapperStyle, className, ...props }: any) => (
  <div
    className={cn(
      'absolute left-0 z-10 rounded-md w-full max-w-[37.5rem] shadow-[0px 4px 16px 0px rgba(0, 0, 26, 0.50)] border border-solid border-neutral-40 bg-white',
      [dropdownOptionsStyle, dropdownMainWrapperStyle || ''],
      className
    )}
    {...props}
  />
);
export const MainWrapper = ({ mainWrapperStyle, className, ...props }: any) => (
  <div className={cn(mainWrapperStyle, className)} {...props} />
);
